(function() {
    'use strict';

    angular
        .module('atheer.conversation')
        .controller('ConversationMembersDialogController', ConversationMembersDialogController);

    /* @ngInject */
    function ConversationMembersDialogController($mdDialog, members, ConversationMemberUtil) {
        var vm = this;

        vm.members = members || [];
        vm.getMemberDisplayName = ConversationMemberUtil.getDisplayName;

        vm.close = function() {
            $mdDialog.cancel();
        };
    }
})();
